import {BaseEntity} from "../common/base-entity";
import {identificationStatus} from "./constants";
import {CirfUdf} from "../cirf/cirf-udf";

export class Identification extends BaseEntity {
    constructor(identification?: Identification) {
        super(identification);
        if(identification){
            this.identificationUdfs = [];
            if(identification.identificationUdfs){
                identification.identificationUdfs.forEach((udf)=>{
                    this.identificationUdfs.push(new CirfUdf(udf));
                });
            }
        }
        if(!this.identificationTypeCode){
            this.identificationTypeCode = '';
        }
        if(!this.identificationNumber){
            this.identificationNumber = '';
        }
        if(!this.placeOfIssue){
            this.placeOfIssue = '';
        }
        if(!this.expiryDate){
            this.expiryDate = '';
        }
        if(!this.country){
            this.country = '';
        }
    }

    identificationTypeCode: string;
    identificationNumber: string;
    placeOfIssue: string;
    expiryDate: string;
    country: string;
    // The following field is used to identify the primary & secondary identification
    // instead of relying on the index
    identificationStatus: string;
    identificationUdfs : CirfUdf[] = [];

    get entityName() : string {
        return 'identification';
    }

}